import React from "react"
import { Typography, Stack, Link } from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"
import { Link as ReactRouterLink } from "react-router-dom"

export function MemberIdError(): JSX.Element {
  const intl = useIntl()

  const headerText = intl.formatMessage({ defaultMessage: "Something’s not working" })

  return (
    <Stack alignItems={"center"}>
      <Stack alignItems={"center"}>
        <Typography variant="h2" marginBottom={(theme) => theme.spacing(theme.tokens.spacing.md)}>
          {headerText}
        </Typography>
        <Typography marginBottom={(theme) => theme.spacing(theme.tokens.spacing.md)}>
          <FormattedMessage defaultMessage="Try reloading this page. " />
        </Typography>
        <Typography>
          <FormattedMessage
            defaultMessage="If the problem persists, feel free to <link>contact us</link>."
            values={{
              link: (linkContent) => (
                <Link component={ReactRouterLink} to="/send-a-message">
                  {linkContent}
                </Link>
              )
            }}
          />
        </Typography>
      </Stack>
    </Stack>
  )
}
